import { toNumber } from "lodash";

export const AUTH_COOKIE_EXPIRES_DAYS = toNumber(process.env.REACT_APP_AUTH_COOKIE_EXPIRES_DAYS) || 30;
export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー。";
export const PREVENT_URL = "不適切なURLです。";
export const DEFAULT_TIMER = 500;
export const MAX_INTEGER = 2147483646;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const CACHED_TIME = 10000;
export const MAXIMUM_NUMBER_VALIDATION = 9999999999999;
export const MAX_CHARACTER_INPUT_VALIDATION = 255;
export const MAX_COMPANY_INPUT_VALIDATION = 60;
export const MAX_REPRESENTATIVE_NAME_INPUT_VALIDATION = 26;
export const MAX_COMPANY_ADDRESS_INPUT_VALIDATION = 80;
export const MAX_TEXT_INPUT_VALIDATION = 1000;
export const MAX_INTEGER_INPUT_VALIDATION = 10;
export const MAX_YEAR_INPUT_VALIDATION = 4;
export const MAX_BIG_INTEGER = "9223372036854775807";
export const MAX_CHARACTER_FULLNAME_VALIDATION = 104;
export const MAX_CHARACTER_EMAIL_VALIDATION = 60;
export const MAX_CHARACTER_PHONE_VALIDATION = 15;
export const MAX_CHARACTER_ZIP_CODE = 7;
export const MAX_PARTNER_NAME_INPUT_VALIDATION = 60;
export const MAX_RECRUITMENT_SOURCE_NAME_INPUT_VALIDATION = 26;
export const MAX_MANAGEMENT_NUMBER_VALIDATION = 6;
export const STATUS_ACTIVE = "active";
export const STATUS_INACTIVE = "inactive";
export const MAX_SMALL_INT_VALIDATION = 32767;
export const MAX_PASSWORD_INPUT_VALIDATION = 64;
export const MAX_MATCH_LICENSE_NUMBER_VALIDATION = 20;

// --- Shared UI feedback messages ---
export const TITLE_REQUIRED_MESSAGE = "タイトルを入力してください。";
/** Saved-condition titles are capped at 15 by the API; the column itself still holds 40,
 * so titles saved under the old cap keep working until they are edited. */
export const SAVED_CONDITION_TITLE_MAX_LENGTH = 15;
export const TITLE_MAX_LENGTH_MESSAGE = `${SAVED_CONDITION_TITLE_MAX_LENGTH}文字以内で入力してください。`;
export const COPY_SUCCESS_MESSAGE = "コピーしました。";
export const COPY_FAILED_MESSAGE = "コピーに失敗しました。";
export const UNSAVED_CHANGES_MESSAGE = "行った変更が保存されない可能性があります。";
export const UNSAVED_CHANGES_CONFIRM_MESSAGE = "入力が完了していません。このまま戻ってもよろしいですか？";
export const COMMENT_MAX_LENGTH_MESSAGE = (max: number) => `コメントは${max}文字以内で入力してください。`;
export const INPUT_MAX_LENGTH_MESSAGE = (max: number) => `${max}文字以内で入力してください。`;
export const INPUT_NEGATIVE_NUMBER_MESSAGE = "0以上を入力してください。";
export const INPUT_MAX_NUMBER_MESSAGE = (max: number) => `${max}以下で入力してください。`;
export const CSV_EXPORT_FAILED_MESSAGE = "CSV出力に失敗しました。";
export const DOWNLOAD_SUCCESS_MESSAGE = "ダウンロードが完了しました。";
export const DOWNLOAD_FAILED_MESSAGE = "ダウンロードに失敗しました。";
export const CASE_ID_NOT_FOUND_MESSAGE = "案件IDが見つかりません。";
export const NO_TALENT_MESSAGE = "人材がありません。";
export const CASE_MATCH_INFO_NOT_FOUND_MESSAGE = "案件マッチング情報が取得できませんでした。";
export const ISSUE_SHARE_URL_GUIDE_MESSAGE = "パスワードを設定してURL発行してください。";
export const JLPT_CERTIFICATE_REQUIRED_MESSAGE = "日本語能力証明書等（実習修了証明含む）は必須です。";
export const SPECIFIC_SKILL_CERTIFICATE_REQUIRED_MESSAGE = "特定技能合格証等は必須です。";
